import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const resetStackletPassword = (id: number): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'reset_password' },
  });
